import React, { useEffect, useState, useContext } from "react"
import AuthContext from "../../../../../contexts/Auth"
import ModalComponent from "../ModalComponent"
import { TabEditAndHistory } from "../TabEditAndHistory"
import intl from "react-intl-universal"
import styles from "./index.module.scss"
import SwitchComponent from "../../../../atoms/Switch"
import Button from "../../../../atoms/Button"
import { WestgardRules } from "../WestgardRules"
import { getWestGardRoles, listHistory } from "../../../../../services/ciq"
import RcmpLoading from "../../../../atoms/Loading"
import { MaximunImprecisun } from "../MaximunImprecisiun"
import { WestgardRulesContext } from "../../../../../contexts/Equipments"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import { HistoryComponent } from "../HistoryComponent"
import Input from "../../../../atoms/Input"
import { ModalInformation } from "../ModalInformation"

const N_INTEGRATION_CODE_MAX_CHARACTERES = 256

export const ModalSettingsEquipment = ({
  tableBodyArray,
  setTableBodyArray,
  setbIsOpenModalSettingsEquiment,
  isTabEdit,
  setIsTabEdit,
  isSwitchSuspense,
  setIsSwitchSuspense,
  setIsCheckedSwitch,
  setIsChanged,
}) => {
  const [rules, setRules] = useState([])
  const [load, setLoad] = useState(false)
  const [dataHistory, setDataHistory] = useState([])
  const [isLoadHistory, setIsLoadHistory] = useState(false)
  const [per_pageHistory, setPerPageHistory] = useState(1)
  const [search_type, setSearchType] = useState("")
  const [text_type, setTextType] = useState("")
  const [infoInfinitScroll, setInfoInfinitScroll] = useState({})
  const [isChangedAnalayte, setIsChangedAnalayte] = useState(false)
  const [isCancelModal, setIsCancelModal] = useState(false)

  const { oUser } = useContext(AuthContext)

  const cUserTimeZone = oUser?.data?.user_ctimezone

  const [bIsError, setBIsError] = useState({
    bIsErrorJustify: false,
    bIsErrorAmount: false,
    bIsAnyErrorCIntegration: false,
    bIsErrorCIntegrationCodeDuplicate: false,
    bIsErrorCIntegrationCodeWhiteSpaces: false,
    bIsErrorCIntegrationCodeMaxCharacters: false,
  })

  const [cTextAmount, setCTextAmount] = useState("")
  const [cJustify, setCJustify] = useState("")
  const [biologicalVariation, setBiologicalVariation] = useState(false)
  const [manualImprecisium, setManualImprecisium] = useState(true)

  const { dataConfigAnalyte, setDataConfigAnalyte, listRulesSelectedUnique, isSigma } =
    useContext(WestgardRulesContext)

  const [bActiveMaximumInaccuracy, setBActiveMaximumInaccuracy] = useState(
    dataConfigAnalyte?.eqpanlt_bmax_imprecision,
  )
  const [cIntegrationCode, setCIntegrationCode] = useState(
    dataConfigAnalyte?.eqpanlt_cintegration_code,
  )

  const dataLocal = JSON.parse(localStorage.getItem("dataConfigAnalyte"))

  const rolesWestGard = async () => {
    try {
      setLoad(true)

      const response = await getWestGardRoles()
      const newData = response.data.data.map((item) => ({
        eqpanltwgr_wgrdr_nid: item.wgrdr_nid,
        eqpanltwgr_wgrdr_cname: item.wgrdr_cname,
      }))
      localStorage.setItem("dataConfigAnalyte", JSON.stringify(dataConfigAnalyte))

      const analyteWestgardRules = dataConfigAnalyte.eqpanlt_westgard.map((item) => ({
        eqpanltwgr_wgrdr_nid: item.eqpanltwgr_wgrdr_nid,
        eqpanltwgr_eaction: item.eqpanltwgr_eaction,
        eqpanltwgr_bstatus: item.eqpanltwgr_bstatus,
      }))

      for (let i = 0; i < analyteWestgardRules.length; i++) {
        const id = analyteWestgardRules[i].eqpanltwgr_wgrdr_nid
        const match = newData.find((item) => item.eqpanltwgr_wgrdr_nid === id)

        if (!match) {
          analyteWestgardRules[i].eqpanltwgr_wgrdr_cname = "N/A"
        } else {
          analyteWestgardRules[i].eqpanltwgr_wgrdr_cname = match.eqpanltwgr_wgrdr_cname
        }
      }

      setRules(analyteWestgardRules)
    } catch (err) {
      console.error(err)
    } finally {
      setLoad(false)
    }
  }

  const getHistoricHistoric = async (id, perPage, searchType, textType) => {
    try {
      setDataHistory([])
      setIsLoadHistory(true)
      const { data: dt } = await listHistory(
        id,
        perPage,
        searchType,
        textType,
        "equipment-analyte",
      )

      const newDataHistory = dt.data.data.map((item) => {
        const [data, hour] = fnFormatDateFromUTC(
          item.history_dupdated,
          "DD/MM/YYYY - HH:mm",
          cUserTimeZone,
        ).split(" - ")

        return {
          ...item,
          history_caction: item.history_caction,
          history_data: data,
          history_hour: hour,
          history_user_cname: item.history_user?.cname,
        }
      })

      setDataHistory(newDataHistory)

      setInfoInfinitScroll({
        last_page: dt.data.last_page,
        next_page_url: dt.data.next_page_url,
        data_length: dt.data.data.length,
      })
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadHistory(false)
    }
  }

  useEffect(() => {
    getHistoricHistoric(
      dataConfigAnalyte.eqpanlt_nid,
      per_pageHistory,
      search_type,
      text_type,
    )
  }, [dataConfigAnalyte.eqpanlt_nid, per_pageHistory, search_type, text_type])

  useEffect(() => {
    if (
      dataLocal?.anlt_nid !== dataConfigAnalyte?.eqpanlt?.anlt_nid &&
      dataConfigAnalyte?.eqpanlt?.anlt_type ===
        intl.get("ciq.types_analytes.quantitative")
    ) {
      rolesWestGard()
      setCJustify("")
      setCTextAmount("")
    } else {
      setRules(
        dataConfigAnalyte?.eqpanlt_westgard?.map((item) => ({
          eqpanltwgr_wgrdr_nid: item.eqpanltwgr_wgrdr_nid,
          eqpanltwgr_eaction: item.eqpanltwgr_eaction,
          eqpanltwgr_bstatus: item.eqpanltwgr_bstatus,
        })),
      )
      rolesWestGard()
    }
  }, [])

  // validate integration code
  useEffect(() => {
    // validate white space
    if (cIntegrationCode?.length > 0 && cIntegrationCode?.trim() === "") {
      setBIsError({
        ...bIsError,
        bIsErrorCIntegrationCodeWhiteSpaces: true,
        bIsAnyErrorCIntegration: true,
        bIsErrorCIntegrationCodeMaxCharacters: false,
        bIsErrorCIntegrationCodeDuplicate: false,
      })
      return
    } else {
      setBIsError({
        ...bIsError,
        bIsErrorCIntegrationCodeWhiteSpaces: false,
      })
    }

    // validate max characteres
    if (cIntegrationCode?.length > N_INTEGRATION_CODE_MAX_CHARACTERES) {
      setBIsError({
        ...bIsError,
        bIsErrorCIntegrationCodeMaxCharacters: true,
        bIsAnyErrorCIntegration: true,
        bIsErrorCIntegrationCodeWhiteSpaces: false,
        bIsErrorCIntegrationCodeDuplicate: false,
      })
      return
    } else {
      setBIsError({ ...bIsError, bIsErrorCIntegrationCodeMaxCharacters: false })
    }

    // validate same equipment analyte duplicate integration code
    if (fnVerifyDuplicateIntegrationCode()) {
      setBIsError({
        ...bIsError,
        bIsErrorCIntegrationCodeDuplicate: true,
        bIsAnyErrorCIntegration: true,
        bIsErrorCIntegrationCodeWhiteSpaces: false,
        bIsErrorCIntegrationCodeMaxCharacters: false,
      })
      return
    } else {
      setBIsError({ ...bIsError, bIsErrorCIntegrationCodeDuplicate: false })
    }

    setBIsError({ ...bIsError, bIsAnyErrorCIntegration: false })

    // check if integration code has changed
    if ((cIntegrationCode || "") != (dataConfigAnalyte?.eqpanlt_cintegration_code || "")) {
      fnHandleSetChange(true)
    }
  }, [cIntegrationCode])

  const fnHandleSetChange = (bChanged) => {
    setIsChangedAnalayte(bChanged)
    setIsChanged(bChanged)
  }

  const fnHandleOnChangeIntegrationCode = (e) => {
    setCIntegrationCode(e?.target?.value || "")
  }

  const fnVerifyDuplicateIntegrationCode = () => {
    if (!cIntegrationCode || !tableBodyArray?.length || !dataConfigAnalyte) return false

    const bHasDuplicateIntegrationCode = tableBodyArray
      ?.filter((a) => a?.anlt_nid !== dataConfigAnalyte?.anlt_nid)
      ?.some((a) => a?.eqpanlt_cintegration_code === cIntegrationCode)

    return bHasDuplicateIntegrationCode
  }

  const fnIntegrationCodeErrorsMessage = () => {
    const {
      bIsErrorCIntegrationCodeDuplicate,
      bIsErrorCIntegrationCodeMaxCharacters,
      bIsErrorCIntegrationCodeWhiteSpaces,
    } = bIsError

    if (!bIsError?.bIsAnyErrorCIntegration) return null

    if (bIsErrorCIntegrationCodeDuplicate)
      return intl.get("ciq.duplicate_equipment_integration_code")
    if (bIsErrorCIntegrationCodeMaxCharacters)
      return intl.get("form.max_length", { length: N_INTEGRATION_CODE_MAX_CHARACTERES })
    if (bIsErrorCIntegrationCodeWhiteSpaces)
      return intl.get("cant_fill_with_space")

    return null
  }

  const fnHandleOnClose = () => {
    if (isChangedAnalayte) {
      setIsCancelModal(true)

      return
    }

    setbIsOpenModalSettingsEquiment(false)
  }

  return (
    <>
      <ModalComponent
        title={intl.get("ciq.settings_analyte")}
        fnCloseModal={() => setbIsOpenModalSettingsEquiment(false)}
        size={isTabEdit ? "lg" : "xlg"}
      >
        <TabEditAndHistory isTabEdit={isTabEdit} handleActive={setIsTabEdit} />

        {isTabEdit ? (
          <>
            <div className={`${styles.flexBetween} ${styles.mbTwoRem}`}>
              <h3 className={styles.titleConfig}>
                {intl.get("ciq.status_analyte_linked_equipment")}
              </h3>

              <SwitchComponent
                width="10rem"
                label="Status"
                onClick={() => {
                  setIsSwitchSuspense((oldState) => !oldState)
                  fnHandleSetChange(true)
                }}
                cDisabledText={intl.get("ciq.inactive_up")}
                cAbleText={intl.get("ciq.active_up")}
                value={isSwitchSuspense}
              />
            </div>

            <div className={styles.flexStart}>
              <div className={`${styles.containerContent} ${styles.widthFiveRem}`}>
                <p className={styles.label}>ID</p>
                <p className={styles.content}>{dataConfigAnalyte?.eqpanlt?.anlt_nid}</p>
              </div>
              <div className={`${styles.containerContent} ${styles.widthTenRem}`}>
                <p className={styles.label}>
                  {intl.get("ciq.header_table_list_equipment.name")}
                </p>
                <p className={styles.content}>{dataConfigAnalyte?.eqpanlt?.anlt_cname}</p>
              </div>
              <div className={styles.containerContent}>
                <p className={styles.label}>
                  {intl.get("ciq.header_table_link_analytes.type")}
                </p>
                <p className={styles.content}>{dataConfigAnalyte?.eqpanlt?.anlt_type}</p>
              </div>
              <div />
            </div>
            {dataConfigAnalyte?.eqpanlt?.anlt_type ===
              intl.get("ciq.types_analytes.quantitative") && (
              <div className={styles.flexStart}>
                <div className={`${styles.containerContent} ${styles.widthFiveRem}`}>
                  <p className={styles.label}>Unidade</p>
                  <p className={styles.content}>
                    {dataConfigAnalyte?.eqpanlt.anlt_unit_of_measure}
                  </p>
                </div>
                <div className={`${styles.containerContent} ${styles.widthTenRem}`}>
                  <p className={styles.label}>
                    {intl.get("ciq.header_table_list_analyte.sector")}
                  </p>
                  <p className={styles.content}>
                    {dataConfigAnalyte?.eqpanlt.anlt_sector.sector_cname}
                  </p>
                </div>
                <div className={styles.containerContent}>
                  <p className={styles.label}>
                    {intl.get("ciq.create_analytes.n_decimals")}
                  </p>
                  <p className={styles.content}>
                    {dataConfigAnalyte?.eqpanlt.anlt_decimal_places}
                  </p>
                </div>
                <div />
              </div>
            )}
            <div className={styles.flexStart}>
              <div className={styles.containerContent}>
                <p className={styles.label}>
                  {intl.get("ciq.header_table_list_equipment.observation")}
                </p>
                <p className={styles.content} style={{ fontWeight: 400 }}>
                  {dataConfigAnalyte?.eqpanlt?.anlt_observation}
                </p>
              </div>
            </div>

            {dataConfigAnalyte?.eqpanlt?.anlt_type !==
              intl.get("ciq.types_analytes.quantitative") && (
              <div className={styles.containerContent}>
                <p className={styles.label}>{intl.get("ciq.opt_results")}</p>
                <div className={styles.start}>
                  {dataConfigAnalyte?.eqpanlt?.anlt_result_options.map((item) => (
                    <span
                      key={item.resultopt_cdescription}
                      className={styles.cdescription}
                    >
                      {item.resultopt_cdescription}
                    </span>
                  ))}
                </div>
              </div>
            )}

            {dataConfigAnalyte?.eqpanlt?.anlt_type ===
              intl.get("ciq.types_analytes.quantitative") && (
              <MaximunImprecisun
                setIsChanged={fnHandleSetChange}
                bActiveMaximumInaccuracy={bActiveMaximumInaccuracy}
                setBActiveMaximumInaccuracy={setBActiveMaximumInaccuracy}
                cJustify={cJustify}
                setCJustify={setCJustify}
                cTextAmount={cTextAmount}
                setCTextAmount={setCTextAmount}
                bIsError={bIsError}
                setBIsError={setBIsError}
                biologicalVariation={biologicalVariation}
                setBiologicalVariation={setBiologicalVariation}
                manualImprecisium={manualImprecisium}
                setManualImprecisium={setManualImprecisium}
              />
            )}

            {dataConfigAnalyte?.eqpanlt?.anlt_type ===
              intl.get("ciq.types_analytes.quantitative") &&
              (load ? (
                <div style={{ marginBottom: "1rem" }}>
                  <RcmpLoading bShow={true} size={60} />
                </div>
              ) : (
                <WestgardRules
                  isSelectedSigma={dataConfigAnalyte.eqpanlt_bsigma}
                  isRulesRequiredSigma={
                    dataConfigAnalyte.eqpanlt_covar !== null &&
                    dataConfigAnalyte.eqpanlt_sigma !== null &&
                    dataConfigAnalyte.eqpanlt_drm !== null
                  }
                  rules={rules}
                  setRules={setRules}
                  setIsChanged={fnHandleSetChange}
                />
              ))}
            <div className={styles.integrationCodeFieldContainer}>
              <Input
                label={intl.get("ciq.integration_code")}
                width="100%"
                placeholder={intl.get("type_here")}
                value={cIntegrationCode}
                onChange={fnHandleOnChangeIntegrationCode}
                hasError={bIsError?.bIsAnyErrorCIntegration}
                helperText={fnIntegrationCodeErrorsMessage()}
              />
            </div>
            <div
              className={styles.flexBetween}
              style={{
                margin: "0rem",
              }}
            >
              <Button
                variant="outline"
                onClick={fnHandleOnClose}
              >
                {intl.get("cancel")}
              </Button>
              <Button
                onClick={() => {
                  if (bIsError?.bIsAnyErrorCIntegration) return
                  if (bActiveMaximumInaccuracy && manualImprecisium) {
                    if (cTextAmount === "" || cJustify === "") {
                      if (cTextAmount === "" && cJustify === "") {
                        setBIsError({
                          bIsErrorJustify: true,
                          bIsErrorAmount: true,
                        })
                      } else if (cTextAmount === "") {
                        setBIsError({
                          bIsErrorJustify: false,
                          bIsErrorAmount: true,
                        })
                      } else if (cJustify === "") {
                        setBIsError({
                          bIsErrorJustify: true,
                          bIsErrorAmount: false,
                        })
                      }
                      return
                    }
                  }
                  setIsCheckedSwitch(isSwitchSuspense)

                  const westgardRules = dataConfigAnalyte.eqpanlt_westgard.map(
                    (elemento) => {
                      const correspondenteSegundo = listRulesSelectedUnique.find(
                        (segundoElemento) =>
                          segundoElemento.eqpanltwgr_wgrdr_nid ===
                          elemento.eqpanltwgr_wgrdr_nid,
                      )

                      if (correspondenteSegundo) {
                        return {
                          ...elemento,
                          eqpanltwgr_bstatus: correspondenteSegundo.eqpanltwgr_bstatus,
                          eqpanltwgr_eaction: correspondenteSegundo.eqpanltwgr_eaction,
                        }
                      } else {
                        return {
                          ...elemento,
                        }
                      }
                    },
                  )

                  const newDataConfigAnalyte = {
                    ...dataConfigAnalyte,
                    eqpanlt_eimprecision_type:
                      bActiveMaximumInaccuracy && biologicalVariation
                        ? "BIOLOGICAL_VARIATION"
                        : bActiveMaximumInaccuracy && !biologicalVariation
                        ? "MANUAL"
                        : "MANUAL",
                    eqpanlt_westgard: westgardRules,
                    eqpanlt_bmax_imprecision: bActiveMaximumInaccuracy,
                    anlt_bstatus:
                      isSwitchSuspense === true ||
                      isSwitchSuspense === "Ativo" ||
                      isSwitchSuspense === "Active"
                        ? intl.get("ciq.list_analytes.active")
                        : intl.get("ciq.list_analytes.inactive"),
                    status: isSwitchSuspense,
                    eqpanlt_bsigma: isSigma,
                    eqpanlt_cintegration_code: cIntegrationCode,
                  }

                  setDataConfigAnalyte(newDataConfigAnalyte)

                  const data = tableBodyArray.map((item) => {
                    if (item.anlt_nid === newDataConfigAnalyte?.eqpanlt?.anlt_nid) {
                      return {
                        ...item,
                        anlt_bstatus:
                          isSwitchSuspense === true ||
                          isSwitchSuspense === "Ativo" ||
                          isSwitchSuspense === "Active"
                            ? intl.get("ciq.list_analytes.active")
                            : intl.get("ciq.list_analytes.inactive"),
                      }
                    } else {
                      return item
                    }
                  })
                  // faz alteracao do imprecisao maxima
                  setTableBodyArray(
                    data.map((item) => {
                      if (item.anlt_nid === newDataConfigAnalyte?.eqpanlt?.anlt_nid) {
                        return { ...item, ...newDataConfigAnalyte }
                      } else {
                        return item
                      }
                    }),
                  )

                  setbIsOpenModalSettingsEquiment(false)
                }}
              >
                {intl.get("save_settings")}
              </Button>
            </div>
          </>
        ) : (
          <HistoryComponent
            searchHistory="analyte-equipment"
            history={dataHistory}
            infoInfinitScroll={infoInfinitScroll}
            setPerPage={setPerPageHistory}
            perPage={per_pageHistory}
            isLoadHistory={isLoadHistory}
            setSearchType={setSearchType}
            setSearchText={setTextType}
          />
        )}
      </ModalComponent>
      {isCancelModal && (
        <ModalInformation
          bgBtn="#1ECB4F"
          bShow={isCancelModal}
          title={intl.get("ciq.settings_analyte")}
          description={intl.get("ciq.changes_not_save")}
          onClose={() => setbIsOpenModalSettingsEquiment(false)}
          onCancel={() => setIsCancelModal(false)}
        />
      )}
    </>
  )
}
